module.exports = __webpack_public_path__ + "img/logo.ba41a44d.svg";